import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import publicRoutes from '../config/publicRoutes.json';

/** These are distinct public tools. Filter/query states consolidate to their tool. */
export function RouteMetadata() {
  const { pathname } = useLocation();
  useEffect(() => {
    const path = pathname.replace(/\/$/, '') || '/';
    const meta = publicRoutes[path as keyof typeof publicRoutes];
    if (!meta) return;
    const canonical = `https://ai.tacostreetlocating.com${path}`;
    document.title = meta.title;
    const fields = [
      ['name', 'description', meta.description],
      ['property', 'og:title', meta.title],
      ['property', 'og:description', meta.description],
      ['property', 'og:url', canonical],
      ['property', 'og:type', 'website'],
      ['property', 'og:image', 'https://ai.tacostreetlocating.com/hero-neon.png'],
      ['name', 'twitter:card', 'summary_large_image'],
      ['name', 'twitter:image', 'https://ai.tacostreetlocating.com/hero-neon.png'],
      ['name', 'twitter:title', meta.title],
      ['name', 'twitter:description', meta.description],
    ];
    fields.forEach(([attr, name, content]) => {
      let el = document.head.querySelector<HTMLMetaElement>(`meta[${attr}="${name}"]`);
      if (!el) { el = document.createElement('meta'); el.setAttribute(attr, name); document.head.appendChild(el); }
      el.content = content;
    });
    const links = Array.from(document.head.querySelectorAll<HTMLLinkElement>('link[rel="canonical"]'));
    const link = links.shift() || document.createElement('link');
    links.forEach(el => el.remove());
    link.rel = 'canonical'; link.href = canonical;
    if (!link.isConnected) document.head.appendChild(link);
    return () => { link.remove(); };
  }, [pathname]);
  return null;
}
